// ABOUTME: Upload page for manual media: builds a review grid from selected
// ABOUTME: files and optional CSV, uploads direct to Cloudinary, batch-creates assets.

const MAX_FILES = 200;
const MAX_BYTES = 20 * 1024 * 1024;
const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
const UPLOAD_CONCURRENCY = 4;

let rows = [];

document.addEventListener('turbo:load', function() {
  const container = document.getElementById('media-upload');
  if (!container) return;

  rows = [];
  document.getElementById('media-upload-files').addEventListener('change', onFilesSelected);
  document.getElementById('media-upload-csv').addEventListener('change', onCsvSelected);
  document.getElementById('media-upload-submit').addEventListener('click', function() {
    uploadAll(container.dataset.signUrl, container.dataset.createUrl);
  });
});

function fileAllowed(file) {
  if (ALLOWED_TYPES.includes(file.type)) return true;
  return /\.(jpe?g|png|webp)$/i.test(file.name);
}

function showError(message) {
  const errors = document.getElementById('media-upload-errors');
  const alert = document.createElement('div');
  alert.className = 'alert alert-danger';
  alert.textContent = message;
  errors.appendChild(alert);
}

function onFilesSelected(event) {
  document.getElementById('media-upload-errors').innerHTML = '';
  const files = Array.from(event.target.files);
  if (files.length > MAX_FILES) {
    showError('Too many files selected (max ' + MAX_FILES + ').');
    event.target.value = '';
    return;
  }

  rows.forEach(function(row) { URL.revokeObjectURL(row.thumbnailUrl); });
  rows = [];
  files.forEach(function(file) {
    if (!fileAllowed(file)) {
      showError(file.name + ': unsupported file type.');
    } else if (file.size > MAX_BYTES) {
      showError(file.name + ': larger than 20MB.');
    } else {
      rows.push({ file: file, thumbnailUrl: URL.createObjectURL(file), status: 'ready' });
    }
  });
  renderGrid();
}

function renderGrid() {
  const grid = document.getElementById('media-upload-grid');
  const tbody = grid.querySelector('tbody');
  tbody.innerHTML = '';
  rows.forEach(function(row, index) {
    const tr = document.createElement('tr');
    tr.innerHTML =
      '<td><img src="' + row.thumbnailUrl + '" style="max-width:60px;max-height:60px"></td>' +
      '<td class="media-upload-row__filename"></td>' +
      '<td><input type="text" class="form-control input-sm" data-field="tags" data-index="' + index + '"></td>' +
      '<td><input type="text" class="form-control input-sm" data-field="description" data-index="' + index + '"></td>' +
      '<td><input type="date" class="form-control input-sm" data-field="contentDate" data-index="' + index + '"></td>' +
      '<td><input type="text" class="form-control input-sm" data-field="attribution" data-index="' + index + '"></td>' +
      '<td class="media-upload-row__status"></td>';
    tr.querySelector('.media-upload-row__filename').textContent = row.file.name;
    tr.querySelector('[data-field="tags"]').value = row.tags || '';
    tr.querySelector('[data-field="description"]').value = row.description || '';
    tr.querySelector('[data-field="contentDate"]').value = row.contentDate || '';
    tr.querySelector('[data-field="attribution"]').value = row.attribution || '';
    setRowStatus(tr, row);
    tbody.appendChild(tr);
  });
  grid.style.display = rows.length ? '' : 'none';
  document.getElementById('media-upload-submit').disabled = !rows.length;
}

function setRowStatus(tr, row) {
  const cell = tr.querySelector('.media-upload-row__status');
  if (row.status === 'uploading') {
    cell.textContent = 'Uploading ' + Math.round((row.progress || 0) * 100) + '%';
  } else if (row.status === 'created') {
    cell.innerHTML = '<span class="label label-success">Added</span>';
  } else if (row.status === 'error') {
    cell.innerHTML = '<span class="label label-danger"></span>';
    cell.querySelector('span').textContent = row.error || 'Failed';
  } else {
    cell.textContent = '';
  }
}

function updateStatusCells() {
  document.querySelectorAll('#media-upload-grid tbody tr').forEach(function(tr, index) {
    setRowStatus(tr, rows[index]);
  });
}

function readRowInputs() {
  document.querySelectorAll('#media-upload-grid [data-field]').forEach(function(input) {
    rows[parseInt(input.dataset.index, 10)][input.dataset.field] = input.value;
  });
}

function onCsvSelected(event) {
  const file = event.target.files[0];
  if (!file) return;

  file.text().then(function(text) {
    readRowInputs();
    applyCsv(text);
    renderGrid();
  });
}

function parseCsv(text) {
  const result = [];
  let row = [], field = '', inQuotes = false;
  for (let i = 0; i < text.length; i++) {
    const c = text[i];
    if (inQuotes) {
      if (c === '"') {
        if (text[i + 1] === '"') { field += '"'; i++; } else { inQuotes = false; }
      } else { field += c; }
    } else if (c === '"') {
      inQuotes = true;
    } else if (c === ',') {
      row.push(field); field = '';
    } else if (c === '\n' || c === '\r') {
      if (c === '\r' && text[i + 1] === '\n') i++;
      row.push(field); field = '';
      if (row.some(function(f) { return f !== ''; })) result.push(row);
      row = [];
    } else { field += c; }
  }
  row.push(field);
  if (row.some(function(f) { return f !== ''; })) result.push(row);
  return result;
}

function applyCsv(text) {
  const parsed = parseCsv(text);
  if (!parsed.length) return;

  const headers = parsed[0].map(function(h) { return h.trim().toLowerCase(); });
  const filenameCol = headers.indexOf('filename');
  if (filenameCol === -1) {
    showError('CSV is missing a "filename" column.');
    return;
  }

  parsed.slice(1).forEach(function(csvRow) {
    const row = rows.find(function(r) { return r.file.name === csvRow[filenameCol]; });
    if (!row) {
      showError('CSV row "' + csvRow[filenameCol] + '" matches no selected file.');
      return;
    }
    const value = function(name) {
      const col = headers.indexOf(name);
      return col === -1 ? undefined : csvRow[col];
    };
    if (value('tags') !== undefined) row.tags = value('tags').split('|').map(function(t) { return t.trim(); }).filter(Boolean).join(', ');
    if (value('description') !== undefined) row.description = value('description');
    if (value('content_date') !== undefined) row.contentDate = value('content_date');
    if (value('attribution') !== undefined) row.attribution = value('attribution');
  });
}

function csrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]');
  return meta ? meta.content : '';
}

function splitTags(value) {
  return (value || '').split(',').map(function(t) { return t.trim(); }).filter(Boolean);
}

function rowItem(row) {
  const defaults = {
    tags: document.getElementById('media-upload-default-tags').value,
    contentDate: document.getElementById('media-upload-default-date').value,
    attribution: document.getElementById('media-upload-default-attribution').value
  };
  const contentDate = row.contentDate || defaults.contentDate;
  return {
    public_id: row.upload.public_id,
    version: row.upload.version,
    format: row.upload.format,
    tags: splitTags(row.tags || defaults.tags),
    description: row.description || '',
    content_date: contentDate ? new Date(contentDate).toISOString() : '',
    attribution: row.attribution || defaults.attribution || ''
  };
}

function uploadToCloudinary(sign, row, onProgress) {
  return new Promise(function(resolve, reject) {
    const form = new FormData();
    form.append('file', row.file);
    form.append('api_key', sign.api_key);
    form.append('timestamp', sign.timestamp);
    form.append('signature', sign.signature);
    form.append('folder', sign.folder);
    form.append('tags', sign.tags);
    form.append('transformation', sign.transformation);
    form.append('allowed_formats', sign.allowed_formats);

    const xhr = new XMLHttpRequest();
    xhr.open('POST', 'https://api.cloudinary.com/v1_1/' + sign.cloud_name + '/image/upload');
    xhr.upload.addEventListener('progress', function(e) {
      if (e.lengthComputable) onProgress(e.loaded / e.total);
    });
    xhr.addEventListener('load', function() {
      if (xhr.status >= 200 && xhr.status < 300) resolve(JSON.parse(xhr.responseText));
      else reject(new Error('Upload failed (' + xhr.status + ')'));
    });
    xhr.addEventListener('error', function() { reject(new Error('Network error')); });
    xhr.send(form);
  });
}

function uploadAll(signUrl, createUrl) {
  readRowInputs();
  document.getElementById('media-upload-errors').innerHTML = '';
  document.getElementById('media-upload-submit').disabled = true;

  fetch(signUrl, { method: 'POST', headers: { 'X-CSRF-Token': csrfToken() } })
    .then(function(response) {
      if (!response.ok) throw new Error('Could not authorize upload.');
      return response.json();
    })
    .then(function(sign) { return uploadQueue(sign); })
    .then(function() { return createAssets(createUrl); })
    .catch(function(error) { showError(error.message); })
    .then(function() { document.getElementById('media-upload-submit').disabled = false; });
}

function uploadQueue(sign) {
  const pending = rows.filter(function(row) { return row.status !== 'created'; });
  let cursor = 0;

  function next() {
    if (cursor >= pending.length) return Promise.resolve();
    const row = pending[cursor++];
    row.status = 'uploading';
    row.progress = 0;
    updateStatusCells();
    const uploadPromise = row.upload
      ? Promise.resolve(row.upload)
      : uploadToCloudinary(sign, row, function(progress) {
          row.progress = progress;
          updateStatusCells();
        });
    return uploadPromise
      .then(function(upload) { row.upload = upload; row.status = 'uploaded'; })
      .catch(function(error) { row.status = 'error'; row.error = error.message; })
      .then(function() { updateStatusCells(); return next(); });
  }

  const workers = [];
  for (let i = 0; i < UPLOAD_CONCURRENCY; i++) workers.push(next());
  return Promise.all(workers);
}

function createAssets(createUrl) {
  const uploaded = rows.filter(function(row) { return row.status === 'uploaded'; });
  if (!uploaded.length) return Promise.resolve();

  return fetch(createUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken() },
    body: JSON.stringify({ items: uploaded.map(rowItem) })
  })
    .then(function(response) {
      if (!response.ok) throw new Error('Could not save uploads.');
      return response.json();
    })
    .then(function(json) {
      json.results.forEach(function(result) {
        const row = uploaded.find(function(r) { return r.upload.public_id === result.public_id; });
        if (!row) return;
        row.status = result.status === 'created' ? 'created' : 'error';
        row.error = result.error;
      });
      updateStatusCells();
    });
}
